import React from 'react';



const Header = ({ text }) => (<li className="header">{text}</li>);

export default Header;
